import { FC, ReactNode } from 'react'

import { Button } from '@hap/components'

import Link from '../link'

interface Action {
  label: string
  to?: string
  onClick?: () => void
}

interface EmptyStateProps {
  title: string
  description?: ReactNode
  icon?: ReactNode
  actions?: Action[]
}

const EmptyState: FC<EmptyStateProps> = (props) => (
  <div className="text-accent-foreground flex flex-col items-center justify-center gap-4 rounded-md border p-12">
    {props.icon && <div className="text-accent-foreground">{props.icon}</div>}

    <hgroup className="text-center">
      <h2 className="text-2xl font-bold">{props.title}</h2>

      {props.description && <p>{props.description}</p>}
    </hgroup>

    {props.actions?.map((a, i) =>
      a.onClick ? (
        <Button variant="secondary" onClick={a.onClick} key={i}>
          {a.label}
        </Button>
      ) : (
        <Link key={i} to={a.to}>
          {a.label}
        </Link>
      ),
    )}
  </div>
)

export default EmptyState
